import { postWithFormData, put, get } from "../common/Provider";

const uploadSingleFileToS3 = (file, folderName, callbacks, uploadStatusObj) => async (dispatch) => {
  const { successCallback, failureCallback } = callbacks;
  const singleFileUploadFormData = new FormData();
  singleFileUploadFormData.append("image", file);
  singleFileUploadFormData.append("folder", folderName);
  const res = await postWithFormData(
    `api/v1/file/sac_upload_photo_s3`,
    singleFileUploadFormData
  );
  if (res.data?.status === "success") successCallback(res.data, folderName, uploadStatusObj);
  else failureCallback(res, uploadStatusObj);
};

const uploadUserDocuments = (file, folderName, callbacks = {}) => async (dispatch) => {
  dispatch({ type: 'UPLOADING_FILE', payload: { isUploading: true } });
  const { failureCallback, isMultiple } = callbacks;

  const singleFileUploadFormData = new FormData();
  singleFileUploadFormData.append("image", file);
  singleFileUploadFormData.append("folder", folderName);

  const res = await postWithFormData(
    `api/v1/file/sac_upload_photo_s3`,
    singleFileUploadFormData
  );
  dispatch({ type: 'UPLOADING_FILE', payload: { isUploading: false } });
  
  const {status, link} = res?.data || {};
  if (!isMultiple) {
    if (status === "success") {
      updateUserProfile({link}, folderName, callbacks);
    } else {
      failureCallback();
    }
  } else {
    return res;
  }
};

const uploadMultipleFilesToS3 = (files, folderName, callbacks) => async (dispatch) => {
  const { failureCallback, existingFiles = [] } = callbacks;
  const docs = [...existingFiles];
  const allRess = [];
  const res = files.map(async (file) => {
    const resp = await dispatch(uploadUserDocuments(file, folderName, callbacks));
    return resp;
  });

  Promise.allSettled(res).then((results) => {
    results.forEach(result => {
      allRess.push(result?.value?.data);
    })
    const failure = allRess.find(r => r.status === 'failure');
    if (failure) {
      failureCallback();
    } else {
      allRess.forEach(r => r?.link && docs.push(r.link));
      updateUserProfile({docs}, folderName, callbacks);
    }
  });
};

const updateUserProfile = async ({docs = [], link = ''}, folderName, callbacks) => {
  const {successCallback, failureCallback, facultyId} = callbacks;
  const payload = {};
  const url = `api/v1/faculty/verifyApprover?id=${facultyId}`;
  const response = await get(url);
  const {
    data: { success, id },
  } = response || {};

  if (success) {
    payload._id = id;
  } else {
    failureCallback();
    return;
  }

  if (folderName === 'profilePhoto') {
    payload.profile_photo_url = link;
  } else if (folderName === 'phd') {
    payload.phd_documents = docs;
  } else if (folderName === 'other') {
    payload.other_documents = docs;
  }

  const res = await put("api/v1/faculty/edit", payload);

  const {data: {UpdateStatus} = {}} = res || {};
  if (UpdateStatus) {
    successCallback();
  } else {
    failureCallback();
  }
}

// const uploadMultipleFilesToS3 = (payload = {}) => async (dispatch) => {
//   const { selectedFiles = [], formData = {} } = payload;
//   // const photos = [];
//   // console.log(photos);
//   const multipleFilesUploadFormData = new FormData();
//   multipleFilesUploadFormData.append("photos", selectedFiles);
//   multipleFilesUploadFormData.append("folder", "abc1223");
//   const res = await postWithFormData(
//     `api/v1/file/sac_upload_Multiplephoto_s3`,
//     multipleFilesUploadFormData
//   );
//   registerStudent(payload);
// };

const registerStudent = (data = {}) => {
  console.log('DAta', data);
}

export { uploadSingleFileToS3, uploadMultipleFilesToS3, uploadUserDocuments };
